import { motion } from 'framer-motion';
import { FiBell, FiBellOff, FiSunrise, FiClock, FiSun, FiMoon } from 'react-icons/fi';
import { useTheme } from '../../../context/ThemeContext';
import { useState } from 'react';

const PREFERENCES = [
  {
    id: 'theme',
    title: 'Choose Your Theme',
    options: [
      { value: 'light', label: 'Light Mode', icon: FiSun },
      { value: 'dark', label: 'Dark Mode', icon: FiMoon }
    ]
  },
  {
    id: 'reminders',
    title: 'Daily Check-ins',
    options: [
      { value: true, label: 'Enable', icon: FiBell },
      { value: false, label: 'Disable', icon: FiBellOff }
    ]
  },
  {
    id: 'checkInTime',
    title: 'Best Time for You',
    options: [
      { value: 'morning', label: 'Morning', icon: FiSunrise },
      { value: 'evening', label: 'Evening', icon: FiClock }
    ]
  }
];

const PreferencesStep = ({ formData, onInputChange, onNext, onBack }) => {
  const { theme, setTheme } = useTheme();
  const [notificationError, setNotificationError] = useState('');

  const requestNotificationPermission = async () => {
    try {
      if (!("Notification" in window)) {
        throw new Error("This browser does not support notifications");
      }

      const permission = await Notification.requestPermission();
      
      if (permission === "granted") {
        return true;
      } else if (permission === "denied") {
        throw new Error("Please enable notifications in your browser settings");
      } else {
        throw new Error("Notification permission was dismissed");
      }
    } catch (error) {
      console.error('Notification permission error:', error);
      setNotificationError(error.message);
      return false;
    }
  };

  const handlePreferenceChange = async (prefId, value) => {
    if (prefId === 'theme') {
      setTheme(value);
      onInputChange('preferences', prefId, value);
    } 
    else if (prefId === 'reminders' && value === true) {
      const notificationsEnabled = await requestNotificationPermission();
      if (notificationsEnabled) {
        setNotificationError('');
        onInputChange('preferences', prefId, value);
      } else {
        onInputChange('preferences', prefId, false);
      }
    } 
    else {
      onInputChange('preferences', prefId, value);
    }
  };

  return (
    <motion.div
      className="onboarding-step preferences-step"
      initial={{ opacity: 0, x: 100 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -100 }}
    >
      <div className="preferences-content">
        <div className="preferences-header">
          <h2>Your Preferences</h2>
          <p className="step-description">
            Customize your experience
          </p>
        </div>

        <div className="preferences-grid">
          {PREFERENCES.map((pref, index) => (
            <motion.div
              key={pref.id}
              className="preference-section"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <h3>{pref.title}</h3>
              {pref.id === 'reminders' && notificationError && (
                <div className="notification-error">{notificationError}</div>
              )}
              <div className="preference-options">
                {pref.options.map(({ value, label, icon: Icon }) => (
                  <motion.button
                    key={value.toString()}
                    className={`preference-btn ${
                      pref.id === 'theme' 
                        ? theme === value ? 'active' : ''
                        : formData.preferences[pref.id] === value ? 'active' : ''
                    }`}
                    onClick={() => handlePreferenceChange(pref.id, value)}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <Icon />
                    <span>{label}</span>
                  </motion.button>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        <div className="step-buttons">
          <button 
            className="onboarding-btn secondary"
            onClick={onBack}
          >
            Back
          </button>
          <button 
            className="onboarding-btn"
            onClick={onNext}
          >
            Continue
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default PreferencesStep; 